// components/ShareTour/TemplateEditorForm.jsx
import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { SHARE_TEMPLATE_TOKENS } from "../../utils/variables/share_templates"

const TemplateEditorForm = ({ initial, onSave, onCancel }) => {
  const { t } = useTranslation()
  const [name, setName] = useState(initial?.name || "")
  const [body, setBody] = useState(initial?.body || "")
  const [saving, setSaving] = useState(false)
  const textareaRef = useRef(null)

  const insertToken = (key) => {
    const el = textareaRef.current
    const token = `{{${key}}}`
    if (!el) {
      setBody((b) => b + token)
      return
    }
    const start = el.selectionStart ?? body.length
    const end = el.selectionEnd ?? body.length
    const next = body.slice(0, start) + token + body.slice(end)
    setBody(next)
    requestAnimationFrame(() => {
      el.focus()
      el.selectionStart = el.selectionEnd = start + token.length
    })
  }

  const handleSubmit = async () => {
    if (!name.trim() || !body.trim()) return
    setSaving(true)
    try {
      await onSave({ name: name.trim(), format: "text", body })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={t("saved_tours.share.template_name")}
        className="w-full text-sm border border-[#E7EAEF] rounded-xl px-3 py-2
                   text-[#1F2937] focus:outline-none focus:ring-2 focus:ring-[#1F2937]/10"
      />

      <textarea
        ref={textareaRef}
        value={body}
        onChange={(e) => setBody(e.target.value)}
        rows={7}
        placeholder="🏨 Hotel: {{hotel_name}} {{star_suffix}}"
        className="w-full text-sm border border-[#E7EAEF] rounded-xl p-3 font-mono
                   text-[#1F2937] resize-none focus:outline-none focus:ring-2 focus:ring-[#1F2937]/10"
      />

      <div>
        <div className="text-xs text-[#9AA5B4] mb-1.5">
          {t("saved_tours.share.available_tokens")}
        </div>
        <div className="flex flex-wrap gap-1.5 max-h-28 overflow-y-auto">
          {SHARE_TEMPLATE_TOKENS.map((tok) => (
            <button
              key={tok.key}
              type="button"
              onClick={() => insertToken(tok.key)}
              title={tok.label}
              className="px-2 py-1 rounded-lg bg-[#F4F6F9] text-[#1F2937] text-xs font-mono
                         hover:bg-[#E7EAEF] transition-colors"
            >
              {`{{${tok.key}}}`}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-2 mt-1">
        <button
          onClick={onCancel}
          className="flex-1 px-3.5 py-2.5 rounded-xl border border-[#E7EAEF] text-sm font-medium
                     text-[#1F2937] hover:bg-[#F4F6F9] transition-colors"
        >
          {t("saved_tours.share.cancel")}
        </button>
        <button
          onClick={handleSubmit}
          disabled={saving || !name.trim() || !body.trim()}
          className="flex-1 px-3.5 py-2.5 rounded-xl bg-[#1F2937] text-white text-sm font-medium
                     hover:bg-[#111827] transition-colors disabled:opacity-50"
        >
          {saving ? t("saved_tours.share.saving") : t("saved_tours.share.save")}
        </button>
      </div>
    </div>
  )
}

export default TemplateEditorForm
